import React from 'react'
import AvaliacaoIndividual from '../../../components/performance/AvaliacaoIndividual'

export default function IndividualPage() {
  return (
    
            <AvaliacaoIndividual />
          
  )
}
